import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import './admin.css';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const AdminCafeVerde = () => {
  const [variedades, setVariedades] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [stats, setStats] = useState({
    total_variedades: 0,
    paises_importadores: 0
  });
  
  const [formData, setFormData] = useState({
    nombre: '',
    especie: '',
    origen: '',
    altitud: '',
    perfil_taza: '',
    puntaje_sca: ''
  });

  useEffect(() => {
    cargarDatos();
  }, []);

  const cargarDatos = async () => {
    setLoading(true);
    try {
      const response = await api.get('/cafe-verde');
      
      if (response.data) {
        setVariedades(response.data);
        
        const statsCalculadas = {
          total_variedades: response.data.length,
          paises_importadores: 15
        };
        
        setStats(statsCalculadas);
      }
    } catch (error) {
      console.error('Error cargando datos:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const cafeVerdeData = {
        nombre: formData.nombre,
        especie: formData.especie,
        origen: formData.origen,
        altitud: formData.altitud,
        perfil_taza: formData.perfil_taza,
        puntaje_sca: formData.puntaje_sca,
        disponible: true,
        stock_kg: 0
      };

      if (editingId) {
        await api.put(`/cafe-verde/${editingId}`, cafeVerdeData);
        alert('Variedad actualizada correctamente');
      } else {
        await api.post('/cafe-verde', cafeVerdeData);
        alert('Variedad creada correctamente');
      }
      
      resetForm();
      cargarDatos();
    } catch (error) {
      console.error('Error guardando variedad:', error);
      alert('Error al guardar la variedad: ' + (error.response?.data?.error || error.message));
    }
  };

  const resetForm = () => {
    setShowForm(false);
    setEditingId(null);
    setFormData({
      nombre: '',
      especie: '',
      origen: '',
      altitud: '',
      perfil_taza: '',
      puntaje_sca: ''
    });
  };

  const handleEdit = (variedad) => {
    setEditingId(variedad.id);
    setFormData({
      nombre: variedad.nombre || '',
      especie: variedad.especie || '',
      origen: variedad.origen || '',
      altitud: variedad.altitud || '',
      perfil_taza: variedad.perfil_taza || '',
      puntaje_sca: variedad.puntaje_sca || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (id) => {
    if (window.confirm('¿Estás seguro de eliminar esta variedad?')) {
      try {
        await api.delete(`/cafe-verde/${id}`);
        alert('Variedad eliminada');
        cargarDatos();
      } catch (error) {
        console.error('Error eliminando variedad:', error);
        alert('Error al eliminar la variedad');
      }
    }
  };

  if (loading) return <div className="loading">Cargando café verde...</div>;

  return (
    <div className="admin-cafe-verde">
      <div className="page-header">
        <div>
          <h1>🌱 Café Verde - Gestión de Variedades</h1>
          <p>Administra las variedades de café verde</p>
        </div>
        <button onClick={() => setShowForm(!showForm)} className="btn-primary">
          {showForm ? 'Cancelar' : '+ Nueva Variedad'}
        </button>
      </div>

      {/* Estadísticas */}
      <div className="stats-grid">
        <div className="stat-card">
          <div className="stat-icon">🌱</div>
          <div className="stat-info">
            <span className="stat-label">Variedades</span>
            <span className="stat-number">{stats.total_variedades || 0}</span>
          </div>
        </div>
        <div className="stat-card">
          <div className="stat-icon">🌍</div>
          <div className="stat-info">
            <span className="stat-label">Países Importadores</span>
            <span className="stat-number">{stats.paises_importadores || 15}+</span>
          </div>
        </div>
      </div>

      {/* Formulario */}
      {showForm && (
        <div className="form-section">
          <h2>{editingId ? 'Editar Variedad' : 'Nueva Variedad de Café Verde'}</h2>
          <form onSubmit={handleSubmit} className="cafe-verde-form">
            <div className="form-grid">
              <div className="form-group">
                <label>Nombre de la variedad *</label>
                <input
                  type="text"
                  name="nombre"
                  value={formData.nombre}
                  onChange={handleInputChange}
                  placeholder="Ej: Oro Natural Superior"
                  required
                />
              </div>

              <div className="form-group">
                <label>Especie</label>
                <input
                  type="text"
                  name="especie"
                  value={formData.especie}
                  onChange={handleInputChange}
                  placeholder="Ej: Arábica, Robusta, etc."
                />
              </div>

              <div className="form-group">
                <label>Origen *</label>
                <input
                  type="text"
                  name="origen"
                  value={formData.origen}
                  onChange={handleInputChange}
                  placeholder="Ej: Veracruz, México"
                  required
                />
              </div>

              <div className="form-group">
                <label>Altitud</label>
                <input
                  type="text"
                  name="altitud"
                  value={formData.altitud}
                  onChange={handleInputChange}
                  placeholder="Ej: 1,400 - 1,600 msnm"
                />
              </div>

              <div className="form-group">
                <label>Perfil de taza</label>
                <input
                  type="text"
                  name="perfil_taza"
                  value={formData.perfil_taza}
                  onChange={handleInputChange}
                  placeholder="Ej: Chocolate, nuez, caramelo"
                />
              </div>

              <div className="form-group">
                <label>Puntaje SCA</label>
                <input
                  type="text"
                  name="puntaje_sca"
                  value={formData.puntaje_sca}
                  onChange={handleInputChange}
                  placeholder="Ej: 85+"
                />
              </div>
            </div>

            <div className="form-actions">
              <button type="submit" className="btn-primary btn-large">
                {editingId ? 'Actualizar Variedad' : 'Guardar Variedad'}
              </button>
            </div>
          </form>
        </div>
      )}

      {/* Grid de variedades */}
      {variedades.length === 0 ? (
        <div className="no-data">
          <p>No hay variedades de café verde registradas.</p>
          <button onClick={() => setShowForm(true)} className="btn-primary">
            + Crear primera variedad
          </button>
        </div>
      ) : (
        <div className="variedades-grid">
          {variedades.map(item => (
            <div key={item.id} className="variedad-card">
              <div className="variedad-header">
                <h3>{item.nombre}</h3>
              </div>

              <div className="variedad-details">
                {item.especie && (
                  <div className="detail-item">
                    <span className="detail-label">🌱 Especie</span>
                    <span className="detail-value">{item.especie}</span>
                  </div>
                )}
                <div className="detail-item">
                  <span className="detail-label">📍 Origen</span>
                  <span className="detail-value">{item.origen}</span>
                </div>
                {item.altitud && (
                  <div className="detail-item">
                    <span className="detail-label">⛰️ Altitud</span>
                    <span className="detail-value">{item.altitud}</span>
                  </div>
                )}
                {item.perfil_taza && (
                  <div className="detail-item">
                    <span className="detail-label">👃 Perfil</span>
                    <span className="detail-value">{item.perfil_taza}</span>
                  </div>
                )}
                {item.puntaje_sca && (
                  <div className="detail-item">
                    <span className="detail-label">🏆 Puntaje</span>
                    <span className="detail-value">{item.puntaje_sca}</span>
                  </div>
                )}
              </div>

              <div className="variedad-acciones">
                <button 
                  onClick={() => handleEdit(item)}
                  className="btn-icon"
                  title="Editar"
                >
                  ✏️
                </button>
                <button 
                  onClick={() => handleDelete(item.id)}
                  className="btn-icon"
                  title="Eliminar"
                >
                  🗑️
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AdminCafeVerde;